import { __assign, __extends } from "tslib";
import React from 'react';
import BaseViewer from './Base';
import omit from 'lodash/omit';
import mergeTheme from '../Themes/mergeTheme';
import customboxTheme from '../Themes/Viewer/custombox.scss';
var CustomBoxViewer = /** @class */ (function (_super) {
    __extends(CustomBoxViewer, _super);
    function CustomBoxViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.theme = mergeTheme(customboxTheme, _this.props.theme);
        return _this;
    }
    CustomBoxViewer.prototype.render = function () {
        var restProps = omit(this.props, ['theme']);
        return (React.createElement("div", { className: 'da-editor-custombox' },
            React.createElement(BaseViewer, __assign({ theme: this.theme, showMediaAlwaysSmall: false, fixedParagraph: false }, restProps))));
    };
    return CustomBoxViewer;
}(React.Component));
export default CustomBoxViewer;
//# sourceMappingURL=CustomBox.js.map